var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.data,"show-checkbox":"","node-key":"id","props":_vm.defaultProps,"default-checked-keys":_vm.settings,"default-expand-all":""},on:{"check":_vm.handleCheckedFieldsChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }